import loadable from '@loadable/component'

import { I18nShape } from '@tribeplatform/react-components/i18n'
import { PostListProps } from '@tribeplatform/react-components/PostList'
import { RegisteredPostListBlock as DumbRegisteredPostListBlock } from '@tribeplatform/react-slate-kit/blocks/registered'
import { RegisteredBlock } from '@tribeplatform/react-slate-kit/types'

const Component = loadable(() => import('./Block'), {
  resolveComponent: m => m.PostListBlock,
})

export const RegisteredPostListBlocks = (
  intl: I18nShape,
): RegisteredBlock<PostListProps> => ({
  recommendedName: DumbRegisteredPostListBlock(intl).recommendedName,
  Component,
  config: DumbRegisteredPostListBlock(intl).config,
})
